// ----------------------------------------------------------------------------
// Component: Narrow Campaign Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_campaign-grid.scss';